module.exports = __webpack_public_path__ + "static/media/ro.583d4688.svg";


//////////////////
// WEBPACK FOOTER
// ./~/react-flags-select/flags/ro.svg
// module id = 1145
// module chunks = 0